'use strict';

module.exports = '3.11.0';
